import { ChatApi } from "@virtualprogaming/js-public-sdk";
import { useMemo } from "react";

import { useApiConfig } from "~/utils";

export function useChatApi() {
  const config = useApiConfig();
  return useMemo(() => new ChatApi(...config), [config]);
}
